/**
 * Preview of space used for spacePreview component.
 */

import * as actionTypes from "../actions/actionTypes";

export default function spacePreviews(state = {}, action) {
  switch (action.type) {
    case actionTypes.FETCH_SPACE_PREVIEW_SUCCESS: {
      const preview = action.response.result;
      return { ...state, [preview.id]: preview };
    }
    default:
      return state;
  }
}
